import { createApp } from "vue";
import App from "./components/App.vue"; // A parent wrapper component
import router from "./router";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const app = createApp(App);
const options = {
    // You can set your default options here
};

app.use(Toast, options);
app.use(router).mount("#app");
